const AGENT_ID = {"basico":"JIK0FYPPNS",
                        "completo":"JIK0FYPPNS"
                    };
const AGENT_ALIAS_ID = {"basico":"TSTALIASID",
                        "completo":"TSTALIASID"
                        };
export { AGENT_ID, AGENT_ALIAS_ID };
